import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { PalletLabelRequestModel } from "src/app/models/shipment.model";

import { saveAs } from "file-saver";

import { Subject, takeUntil } from "rxjs";

import { ShipmentService } from "src/app/services/shipment.service";
import { AuthService } from "src/app/services/auth.service";
import { MainService } from "src/app/services/main.service";
import { CreateWLabelsPayload } from "src/app/models/walmart.model";
import { WalmartService } from "src/app/services/walmart.service";

import { SnackbarComponent } from '../snackbar/snackbar.component';
import { BuyShippingService } from "src/app/services/buy-shipping.service";
import { PrintPalletLabelModel } from "src/app/models/buy-shipping.model";

@Component({
  selector: "app-popup-create-pallets",
  templateUrl: "./popup-create-pallets.component.html",
  styleUrls: ["./popup-create-pallets.component.scss"],
})
export class PopupCreatePalletsComponent implements OnInit, OnDestroy {
  lableType;
  amountToPrint: string;
  shipmentId: string;
  account: string;
  externalMode: boolean;
  downloading: boolean=false;
  private destroy$ = new Subject<void>();
  types: any[];
  SPDLabelType="BARCODE_2D";
  optionPerPage="";
  AmazonType: any[]=[];
  SPDType = [
    {
      value: "BARCODE_2D",
      text: "BARCODE 2D",
    },
    {
      value: "UNIQUE",
      text: "UNIQUE",
    },
    {
      value: "SELLER_LABEL",
      text: "SELLER LABEL",
    },
  ];  
  WalmartType = [
    {
      value: "MIXED SKUS",
      text: "Mixed Skus",
    },
    {
      value: "SINGLE SKU",
      text: "Single Sku",
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<PopupCreatePalletsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private shipmentService: ShipmentService,
    private authService: AuthService,
    public main: MainService,
    private snackBar: MatSnackBar,
    private walmartService: WalmartService,
    private buyShippingService: BuyShippingService
  ) { }

  ngOnInit(): void {
  if(this.data.isSPD && this.data.isBuyShip){
    this.optionPerPage='PackageLabel_Thermal';
    this.lableType="PackageLabel_Thermal";
  } else if(!this.data.isSPD && this.data.isBuyShip){
    this.optionPerPage='PackageLabel_Thermal_NonPCP';
    this.lableType="PackageLabel_Thermal_NonPCP";
  } else{
    this.optionPerPage='PackageLabel_Thermal_NonPCP';
    this.lableType="PackageLabel_Thermal_NonPCP";
  } 
  this.bindAmazonList();
  if (this.data.accountType === "Walmart" && !this.data.isPalletlable) {
    this.types = this.WalmartType;
    this.lableType = "MIXED SKUS";
  } else {
    this.types = this.AmazonType;
    this.lableType = this.data.isPalletlable &&  this.data.accountType === "Walmart" ? "PALLET" : this.lableType;
    this.amountToPrint = this.data.amountToPrint ? this.data.amountToPrint : null 
  } 
  }

  bindAmazonList(){
    this.AmazonType = [
      {
        value: this.optionPerPage,
        text: "1 Per Page",
      },
      {
        value: "PackageLabel_Letter_2",
        text: "2 Per Page",
      },
      {
        value: "PackageLabel_A4_4",
        text: "4 Per Page",
      },
      {
        value: (this.data.isSPD && this.data.isBuyShip) ? "PackageLabel_Letter_6_CarrierLeft" : "PackageLabel_Letter_6",
        text: "6 Per Page",
      },
    ];
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  public onDownloadClick() {
    const user = this.authService.getUserInfo();
    const data: PalletLabelRequestModel = {
      userId: user.userId,
      tenantId: user.tenantId,
      account: this.data.account,
      shipmentId: this.data.shipmentId,
      amountToPrint: parseFloat(this.amountToPrint),
      lableType: this.lableType,
    };
    let apiLink = this.shipmentService.PalletLabel(data);
    

    if (this.data.accountType === "Walmart") {
      const payload: CreateWLabelsPayload = {
        account: this.data.account,
        shipmentId: this.data.shipmentId,
        count: parseFloat(this.amountToPrint),
        loadType: this.lableType,
      };
      apiLink = this.walmartService.CreateWalmartShipmentLabels(payload);
    }

    if (this.data.externalMode) {
      this.dialogRef.close(data);
      return;
    } else {
      this.downloading = true;
      apiLink.pipe(takeUntil(this.destroy$)).subscribe({
        next: (value:any) => {
          try {
            const contentType = value.headers.get("content-type");
            const contentTypePartials = contentType.split("/");
            const fileName = `${this.data.shipmentId}.${contentTypePartials[1]}`;
            saveAs(value.body, fileName);
          } catch (e) {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Something went wrong.',
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
          } finally {
            this.dialogRef.close();
            this.downloading = false;
          }
        },
       error: (e) => {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Something went wrong.',
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
          this.downloading = false;
        }
     });
    }
  }

  public closePopup() {
    this.dialogRef.close();
  }

  public incDecValue(incDec, model) {
    const value = this[model] !== undefined ? parseFloat(this[model]) : 0;
    this[model] =
      incDec === "inc"
        ? this[model] === undefined
          ? 1
          : value + 1
        : this[model] === undefined
        ? 0
        : value > 0
        ? value - 1
        : 0;
  }

  action(e) {
    if (e === "Download") {
      if(this.data.isBuyShip || this.data.accountType !== "Walmart"){
        this.printPalletLabel();
      } else{
        this.onDownloadClick();
      }      
    } else {
      this.dialogRef.close();
    }
  }

  printPalletLabel(){
    this.downloading = true;
    const payload:PrintPalletLabelModel={
      pageType:this.lableType,
      labelType: this.data.isSPD ? "BARCODE_2D" : "PALLET",
      numberOfPallets: parseFloat(this.amountToPrint),
      shipmentHeaderId:this.data.shipmentId,
    }
    this.buyShippingService.printPalletLabel(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.downloading = false;
      if(res.payload){
        saveAs(res.payload.downloadURL, `PalletLabel.pdf`);
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: res.errors[0].message,
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
      }   
      this.dialogRef.close();
      },
     error: (err) => {
      this.downloading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
   }
   });
  }
}
